import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';

import { ListingPreferredTenantSection } from '../components/ListingPreferredTenantSection';
import { getPreferredTenant, getListingIsCharitable } from '../selectors';

const enhance = compose(
  connect(
    createStructuredSelector({
      preferredTenant: getPreferredTenant,
      isCharitable: getListingIsCharitable,
    }),
  ),
);

const ListingPreferredTenantSectionContainer = enhance(
  ListingPreferredTenantSection,
);
export { ListingPreferredTenantSectionContainer };
